const rating = {
  styleOverrides: {
    sizeExtraLarge: {
      fontSize: '40px'
    }
  }
};

export default rating;
